module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "m-nav",
    class: {
      'close-nav': _vm.close
    }
  }, [_c('a', {
    staticClass: "gmail icon-hover",
    attrs: {
      "href": "https://mail.google.com",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "zoom icon-hover",
    attrs: {
      "href": "https://zoom.us/profile",
      "target": "_blank"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "slack icon-hover",
    attrs: {
      "href": "https://slack.com",
      "target": "_blank"
    }
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "chrome",
    attrs: {
      "href": "http://masterminds.jp",
      "target": "_blank"
    }
  }, [_vm._v("© 2018-2019 MasterMinds Inc. NEO for Google Chrome "), _c('i', {
    staticClass: "fa fa-fw fa-chrome"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-401120b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/common/Footer.vue
// module id = 1348
// module chunks = 0